<template>
  <div class="seminarios">
    <v-container class="header-container">
      <h2 class="notranslate ">
        {{ $t("seminarios.title") }}
      </h2>
      <v-img
        data-aos="fade-up"
        class="image__investigacion"
        width="100%"
        height="350px"
        :src="require('@/assets/images/iio-instalaciones.jpg')"
      >
        <h4 class="image-inner-text"></h4>
      </v-img>
      <v-row>
        <v-col cols="12">
          <div data-aos="fade-up" data-aos-delay="50" class="notranslate body mb-14" v-html="$t('seminarios.content')">
        
          </div>
          <v-row>
            <v-col data-aos="fade-up" cols="12" md="12" v-for="(seminar, index) in seminarios" :key="seminar.id">
              <seminar_cell :seminar="seminar" :index="index" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "Seminarios",
  components: {
    Seminar_cell: () => import("@/components/Lists/SeminariosDetailCell.vue")
  },
  data: () => ({
    selectedWorker: null,
    seminarios: []
  }),
  mounted() {
    this.seminarios = [...this.$info.seminarios];
  }
};
</script>
<style lang="scss" scoped>
.seminarios {
  display: flex;
  position: relative;
  padding-top: 100px;
  // padding-top: 200px;
}
.header-container {
  position: relative;
  min-height: 100px;
}
.image__investigacion {
  width: 623px;
  height: 245px;
  background-color: #c4c4c4;
  border-radius: 5px;
  align-self: center;
  margin: 50px auto;
}
.image-inner-text {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  padding-left: 10px;
  color: white;
}

@media (max-width: $screen-lg-min) and (min-width: 500px) {
}

@media only screen and (max-width: $screen-lg-min) {
}

@media (max-width: 960px) {
  .seminarios {
    padding-top: 75px;
  }
}
</style>
